import { TJobForm } from "@/features/job/types/JobForm";

export const pickDuplicateJobData = (data: Partial<TJobForm>): Partial<TJobForm> | undefined => ({
  companyId: data.companyId,
  jobName: data.jobName,
  recruiterId: data.recruiterId,
  companySpecificIndustryId: data.companySpecificIndustryId,
  businessClassificationId: data.businessClassificationId,
  companySpecificBusinessClassificationIds: data.companySpecificBusinessClassificationIds,
  businessContent: data.businessContent,
  employmentType: data.employmentType,
  salaryType: data.salaryType,
  totalAmount: data.totalAmount,
  totalAmountBreakdown: data.totalAmountBreakdown,
  netSalaryEstimate: data.netSalaryEstimate,
  salaryDeductions: data.salaryDeductions,
  hourlyWage: data.hourlyWage,
  otherAllowanceAmount: data.otherAllowanceAmount,
  otherAllowanceDescription: data.otherAllowanceDescription,
  overtimeDescription: data.overtimeDescription,
  bonus: data.bonus,
  bonusInfo: data.bonusInfo,
  salaryRaise: data.salaryRaise,
  salaryRaiseTime: data.salaryRaiseTime,
  jobWorkingTimes: data.jobWorkingTimes,
  regularHolidays: data.regularHolidays,
  irregularHolidays: data.irregularHolidays,
  totalAnnualHolidays: data.totalAnnualHolidays,
  japaneseLevelType: data.japaneseLevelType,
  japaneseLevelOther: data.japaneseLevelOther,
  skillsExperience: data.skillsExperience,
  nationalityIds: data.nationalityIds,
  gender: data.gender,
  residenceStatusIds: data.residenceStatusIds,
  specifiedSkillPassed: data.specifiedSkillPassed,
  selectionProcess: data.selectionProcess,
  companyAccommodation: data.companyAccommodation,
  specifiedSkillNo2: data.specifiedSkillNo2,
  otherBenefits: data.otherBenefits,
  jobMemo: data.jobMemo,
  foreignEmployees: data.foreignEmployees,
  onboardingSupport: data.onboardingSupport,
});
